import React from 'react';
import { FaPaypal } from 'react-icons/fa';
import './PayPalDonateButton.css';

const PayPalDonateButton = () => {
  const emailAddress = "articracingsociety@gmail.com";
  const directDonateLink = `https://www.paypal.com/cgi-bin/webscr?cmd=_donations&business=${emailAddress}&item_name=Lahjoitus+ARS+Toimintaan&currency_code=EUR`;

  return (
    <a 
      href={directDonateLink} 
      target="_blank" 
      rel="noopener noreferrer"
      className="paypal-donate-button"
    >
      <FaPaypal style={{ marginRight: '8px', verticalAlign: 'middle' }} />
      <span style={{ verticalAlign: 'middle' }}>Lahjoita</span>
    </a>
  );
};

export default PayPalDonateButton;